import Vue from "vue";
import Cookies from "js-cookie";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import ElementUIX from 'vue-element-ui-x';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/router/routerGuard";
import ECharts from 'vue-echarts'
import * as echarts from 'echarts'


import plugins from "./plugins";
// //引入vue-office
// import VueOfficeDocx from "@vue-office/docx";
// 引入相关样式
// import "@vue-office/docx/lib/index.css";
// 分页组件
import Pagination from "@/components/Commons/Pagination";
// 文件上传组件
import FileUpload from '@/components/Commons/FileUpload'
// Vue.component("PaginationThe", Pagination);
Vue.component("CustomPagination", Pagination);
Vue.component('FileUpload', FileUpload)
// 全局注册组件
Vue.component('VChart', ECharts)

// 为了让 Vue-ECharts 能正确找到 echarts
Vue.prototype.$echarts = echarts

//全局挂载组件
// Vue.component("VueOfficeDocx", VueOfficeDocx);

Vue.use(plugins);
// 修改 el-dialog 默认点击遮照为不关闭
Element.Dialog.props.closeOnClickModal.default = false;

// Vue.use(ElementUI);
Vue.use(Element, {
  size: Cookies.get("size") || "medium", // set element-ui default size
});

// 引入 Element-UI-X
Vue.use(ElementUIX);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
